import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface OrnamentalDividerProps {
  sx?: SxProps<Theme>;
}

const OrnamentalDivider: React.FC<OrnamentalDividerProps> = ({ sx }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        my: 2,
        ...sx as Record<string, unknown>,
      }}
    >
      <Box
        sx={{
          flex: 1,
          height: '1px',
          background: 'linear-gradient(90deg, transparent 0%, #C9A96E40 50%, #B07A8F30 100%)',
        }}
      />
      <Box
        sx={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #B07A8F 0%, #C9A96E 100%)',
          opacity: 0.4,
        }}
      />
      <Box
        sx={{
          flex: 1,
          height: '1px',
          background: 'linear-gradient(90deg, #B07A8F30 0%, #C9A96E40 50%, transparent 100%)',
        }}
      />
    </Box>
  );
};

export default OrnamentalDivider;
